import {memo} from 'react';

import _ from 'topmeteo/utils/i18n';

import Column from 'topmeteo/general/components/Column';

import Animation from '../Animation';

const AnimationSpeedLabels = {
    'data-speed-slow': _('Slow'),
    'data-speed-fast': _('Fast'),
};

const AnimationControls = ({type, isPlayable}) => isPlayable && [
    <Column key="speed" size={2} className="ctl-loop-speed">
        <div className="met-select-wrapper" {...AnimationSpeedLabels}>
            <Animation.Speed />
        </div>
    </Column>,
    <Column key="play" size={1} className="ctl-loop-play">
        <Animation.PlayButton />
    </Column>,
    <Column key="slider" size={6} className="ctl-loop-slider">
        <Animation.Slider type={type} />
    </Column>,
];

export default memo(AnimationControls);
